import { Box, styled } from '@mui/material';

export const StyledHeaderBox = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  [theme.breakpoints.up('md')]: {
    marginLeft: 20,
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));
